import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './Home';
import IframeWidget from './IframeWidget';

// import ChatPage from "./chat/ChatInterface.jsx";
// import Layout from "./layouts/Layout.jsx";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Home (Landing) */}
        <Route path="/" element={<Home />} />

        {/* After Microsoft Login */}
        <Route path="/welcome" element={<Home />} />

        {/*Iframe Route */}
        <Route path="/iframe" element={<IframeWidget />} />

      </Routes>
    </Router>
  );
};

export default App;
